var map = {
	"./School(0).png": 81671,
	"./School(1).png": 61312,
	"./School(10).png": 36116,
	"./School(11).png": 56955,
	"./School(12).png": 18154,
	"./School(13).png": 17233,
	"./School(14).png": 55584,
	"./School(15).png": 75943,
	"./School(16).png": 43286,
	"./School(17).png": 25149,
	"./School(18).png": 93644,
	"./School(19).png": 88051,
	"./School(2).png": 30877,
	"./School(20).png": 46487,
	"./School(21).png": 58896,
	"./School(22).png": 52717,
	"./School(23).png": 84102,
	"./School(24).png": 12715,
	"./School(25).png": 58436,
	"./School(26).png": 20545,
	"./School(27).png": 99162,
	"./School(28).png": 37583,
	"./School(29).png": 21000,
	"./School(3).png": 65366,
	"./School(30).png": 43894,
	"./School(31).png": 61213,
	"./School(4).png": 62683,
	"./School(5).png": 41844,
	"./School(6).png": 22961,
	"./School(7).png": 23882,
	"./School(8).png": 29631,
	"./School(9).png": 57048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85284;